(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$scope', 'customerService', 'AuthenticationService'];

  /** @ngInject */
  function LoginController($scope, customerService, AuthenticationService) {

    ////////////////
    function  init(){
      AuthenticationService.clearUserCredentials();
    }


    $scope.loginTitle = customerService.getLoginWindowText();
    init();
  }

})();



// WEBPACK FOOTER //
// ./.tmp/components/login/loginController.js